import { useTranslation } from 'react-i18next';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import useTenant from '../../../hooks/useTenant';

/** Nome de quem organiza o concurso (branding do tenant), usado nos textos dos termos. */
export function useOrganizador() {
  const { t } = useTranslation();
  const { branding, currentTenant } = useTenant();
  return branding?.nome || currentTenant?.nome || t('termos.organizadorPadrao');
}

/** Casca comum dos termos do cadastro: título, texto rolável e Cancelar / Aceitar. */
export default function TermoDialog({ open, onClose, onAceitar, titulo, textoAceitar, children }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="termo-dialog-title">
      <DialogTitle id="termo-dialog-title">{titulo}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ '& p': { textAlign: 'justify' } }}>{children}</Box>
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
          <Button variant="outlined" onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button variant="contained" onClick={onAceitar}>
            {textoAceitar}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
